
























































import Vue from 'vue'
import { ApiResponse, Contact, Structure, FormContact, Model } from '@/interfaces'
import { mapState } from 'vuex'

interface SendMailData {
  contacts: string[]
  customText?: string
  structure?: number | null
  chosenModel?: number | null
}

interface Recipient {
  id: number | null
  email: string | null
}

export default Vue.extend({
  props: {
    toggleModal: {
      type: Boolean,
      default: false,
    },
    // sendMailData: {
    //   type: Object as () => SendMailData,
    //   required: false,
    //   default: null,
    // },
    defaultSendContact: {
      type: Object as () => Contact,
      required: false,
      default: null,
    },
    // debiteurSendContact: {
    //   type: Object as () => Contact,
    //   required: false,
    //   default: null,
    // },
  },
  data() {
    return {
      busy: false,
      showModal: false,
      contacts: [] as FormContact[],
      recipients: [] as Recipient[] | null,
      newContact: null as FormContact | null,
      sendMailData: {} as SendMailData,
    }
  },
  computed: {
    ...mapState(['user']),
    modalTitle() {
      return "Envoi d'un document en signature électronique"
    },
    invalidRecipientEmails(): string[] {
      return (this.recipients ?? [])
        .map((recipient: Recipient) => recipient.email)
        .filter((email): email is string => !!email && !this.isValidEmail(email))
    },
  },
  watch: {
    toggleModal(newVal) {
      this.showModal = true
      this.updateModal()
    },
  },
  methods: {
    updateModal() {
      this.recipients = []
      if (this.defaultSendContact) {
        const defaultContact = {
          id: this.defaultSendContact.id,
          label: this.formatSendContact(this.defaultSendContact),
          value: this.defaultSendContact.email ?? null,
        }
        this.addContact(defaultContact)
      }
    },
    closeModal() {
      this.showModal = false
    },
    noSubmit() {
      return false
    },
    submit() {
      // Ajouter ou mettre à jour la propriété contacts dans l'objet sendMailData, avec la valeur de this.recipients, tout en assurant que la réactivité de Vue fonctionne correctement.
      // utile pour écrire dans une variable props qui est normalement readonly
      //this.$set(this.sendMailData, 'contacts', this.recipients)
      // sandMailData n'est plus une props, pas d'intéret etait toujours envoyée vide
      this.sendMailData.contacts = []
      this.recipients?.forEach((recipient: Recipient) => {
        //console.log("id="+recipient.id+" email="+recipient.email)
        this.sendMailData.contacts.push(recipient.id ? recipient.id.toString() : '')
      })
      this.$emit('submit', this.sendMailData)
      this.closeModal()
    },
    disabledForm() {
      return this.invalidRecipientEmails.length > 0
    },
    searchContacts(search: string, cb: CallableFunction) {
      if (search && search.length >= 2) {
        this.busy = true
        let results = [] as FormContact[]
        this.contacts = [] as FormContact[]
        this.$api
          .get('/contacts', {
            params: {
              search: search ?? null,
            },
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse

            apiResponse.data.forEach((contact: Contact) => {
              let contactName = contact.formName
              if (contact.email) {
                contactName = `${contactName} - (${contact.email})`
                this.contacts.push({
                  id: contact.id ?? null,
                  value: contact.email ?? null,
                  label: contactName ?? null,
                })
              }
            })
            results = search ? this.contacts.filter(this.createFilter(search)) : this.contacts
          })
          .finally(() => {
            cb(results)
            this.contacts = results
            this.busy = false
          })
      } else {
        this.contacts = []
      }
    },
    createFilter(search: string) {
      return (contact: FormContact) => {
        return contact.label?.toLowerCase()?.indexOf(search.toLowerCase()) !== -1 ?? null
      }
    },
    formatSendContact(contact: Contact) {
      let contactInfos = `${contact.formName}`
      if (contact.email) {
        contactInfos = `${contactInfos} - (${contact.email})`
      }
      return contactInfos
    },
    findEmailIndex(email: string) {
      return this.recipients?.findIndex((recipient: Recipient) => email === recipient.email) ?? -1
    },
    isValidEmail(email: string | null): boolean {
      if (!email) {
        return false
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      return emailRegex.test(email)
    },
    addContact(contact: FormContact) {
      if (contact.value && this.findEmailIndex(contact.value) === -1) {
        const recipientInfo = {
          id: contact.id,
          email: contact.value,
        } as Recipient
        this.recipients?.push(recipientInfo)
        this.closeContactSelect()
      }
    },
    deleteContact(email: string) {
      const emailIndex = this.findEmailIndex(email)
      if (emailIndex > -1) {
        this.recipients?.splice(emailIndex, 1)
      }
    },
    closeContactSelect() {
      this.newContact = null
      this.contacts = []
    },
  },
})
